/**
 * Main JavaScript Entry Point
 * 
 * @package JD_Theme
 */

import { initMegaMenu } from './modules/megamenu';
import { initMobileMenu } from './modules/mobile-menu';
import { initHeaderScroll } from './modules/header-scroll';
import { initEventsCarousel } from './modules/events-carousel';
import { initHeroMobile } from './modules/hero-mobile';
import { initAnimations } from './modules/animations';
import { initFaqAccordion } from './modules/faq-accordion';
import StepsAnimation from './modules/steps-animation';
import OffersAnimation from './modules/offers-animation';
import ArchiveAnimation from './modules/archive-animation';
import PresentationAnimation from './modules/presentation-animation';
import ContactAnimation from './modules/contact-animation';
import { initEventsCarouselLocation } from './modules/events-carousel-location';
import { initEventsCarouselHome } from './modules/events-carousel-home';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize all modules
  initMegaMenu();
  initMobileMenu();
  initHeaderScroll();
  initEventsCarousel();
  initEventsCarouselLocation();
  initEventsCarouselHome();
  initHeroMobile();
  initFaqAccordion();
  
  // Initialize animations after GSAP is fully loaded
  if (typeof gsap !== 'undefined' && window.gsap) {
    // Wait for window load to ensure all scripts are loaded
    window.addEventListener('load', () => {
      setTimeout(() => {
        initAnimations();
        new StepsAnimation();
        new OffersAnimation();
        new ArchiveAnimation();
        new PresentationAnimation();
        new ContactAnimation();
      }, 100);
    });
  } else {
    console.warn('GSAP not available, animations disabled');
  }
});
